import { gql } from "@apollo/client";

export const GET_LENDERS = gql`
query getLenders($pageOptions: PageOptions,$filters: [LendersFilters], $sortOptions: [SortOptions]) {
    getLenders(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
      data{
      ARCIMEDES_ROW_ID
      NAME
      CITY
      STATE
      CONTACT_NAME
      CONTACT_PHONE
      CONTACT_EMAIL
      DELETED
      NOTES
      }
      TOTAL_COUNT
      success
    }
}
`

export const GET_LENDERS_BY_ID = gql`
query getLender($arcimedes_row_id: ID!){
    getLender(arcimedes_row_id: $arcimedes_row_id){
      success
      message
      data {
        ARCIMEDES_ROW_ID
        NAME
        CITY
        STATE
        CONTACT_NAME
        CONTACT_PHONE
        CONTACT_EMAIL
        DELETED
        NOTES
      }
    }
}
`

export const GET_LENDER_PROPERTIES = gql`
  query v7PropertiesLenderList($lenderId: ID!, $pageOptions: PageOptions) {
    v7PropertiesLenderList(lenderId: $lenderId, pageOptions:$pageOptions) {
      arcimedes_row_id
    source
    status
    hsc_status
    visible
    featured
    name
    address
    city
    state
    zip
    latitude
    longitude
    highlights
    media_kit
    type
    sqft
    list_price
    net_operating_income
    vacancy
    capitalization_rate
    sold_price
    down_payment
    effective_date
    close_of_escrow
    listed_date
    seller_fee_percentage
    lease_type
    lease_commencement_date
    lease_expiration_date
    seller_id
    buyer_id
    year_built
    video_url
    close_cap_rate
    close_noi
    close_price_per_sqft
    price_per_sqft
    listing_agent_1
    listing_agent_2
    listing_agent_3
    listing_agent_4
    buyer_agent_1
    buyer_agent_2
    buyer_agent_3
    buyer_agent_4
    buyer_agent_4_firm
    single_tenant_subcategory
    multi_tenant_subcategory
    tenant_id
    market
    rent_per_sqft
    listing_agent_1_last_name
    listing_agent_2_last_name
    listing_agent_3_last_name
    listing_agent_4_last_name
    buyer_agent_1_last_name
    buyer_agent_2_last_name
    buyer_agent_3_last_name
    buyer_agent_4_last_name
    listing_agent_1_firm
    listing_agent_2_firm
    listing_agent_3_firm
    listing_agent_4_firm
    lender_name
    negotiation_price
    negotiation_cap_rate
    category
    seller_last_name
    hsc_price
    loan_amount
    ltv
    interest_rate
    amortization
    term

    }
  }
`;